(function (ng, app) {

    leaderboardController.$inject = ["$mdDialog", "homeApi", "$window", "$scope"];
    app.controller("leaderboardController", leaderboardController);
    function leaderboardController($mdDialog, homeApi, $window, $scope) {
        var $ctrl = this;
        window.l = this;

        var downloadIncrement = 0;
        ng.extend($ctrl,
            {
                UI: {
                    orderByField: "UpdatedOn",
                    reverseSort: true,
                    darkTheme: localStorage.getItem('darkTheme') === 'true' ? true : false
                },
                close: close,
                toggleSort: toggleSort,
                evalSortClasses: evalSortClasses,
                downloadFile: downloadFile,
                leaderboardFilter: leaderboardFilter
            });

        $scope.$on('themeUpdated', function (event, value) {
            $ctrl.UI.darkTheme = value;
        });

        function close() {
            $mdDialog.hide();
        }

        function toggleSort(name) {
            if ($ctrl.UI.orderByField === name) {
                $ctrl.UI.reverseSort = !$ctrl.UI.reverseSort;
            } else {
                $ctrl.UI.orderByField = name;
            }
        }

        function evalSortClasses(name) {
            var obj = {
                "fa-sort": $ctrl.UI.orderByField !== name,
                "fa-caret-down": $ctrl.UI.orderByField === name && $ctrl.UI.reverseSort,
                "fa-caret-up": $ctrl.UI.orderByField === name && !$ctrl.UI.reverseSort
            };

            return obj;
        }

        function downloadFile() {
            return homeApi.exportMarketingDollars().then(function (data) {

                var f = document.createElement("a");
                f.id = "tmpDownload-" + ++downloadIncrement;
                document.body.appendChild(f);
                f.style = "display: none";

                var fUrl = window.URL.createObjectURL(data);
                f.href = fUrl;
                f.download = "MarketingDollars.xlsx";
                f.click();

                setTimeout(function () {
                    var el = document.getElementById(f.id);
                    document.body.removeChild(el);
                    window.URL.revokeObjectURL(fUrl);
                },
                    100);
            });
        }

        function leaderboardFilter(isGroup) {
            return function (leaderboard) {
                return isGroup ? leaderboard.Name.includes('Office') : !leaderboard.Name.includes('Office');
            };
        }
        $ctrl.$onInit = function () {
            $ctrl.filterByGroup = false;
        };
    }
})(window.angular, window.app); //jshint ignore:line